export default "__VITE_ASSET__C4rkZL5v__"